<div class="end-of-day-files">
  <p-card header="End Of Shift File Upload">
    <div class="p-col-6">
      <p-card header="Upload Files">
        <blob-storage
          [label]="'End Of Shift Files'"
          [fileTypes]="getFileTypes()"
          [entityId]="context?.id"
          [entityParent]="'WorkedShifts'"
          [documentIds]="workedShift?.documentIds"
          [siteId]="context?.site?.id">
        </blob-storage>
      </p-card>
    </div>
  </p-card>
</div>
